import { FilterItem } from './filter.item';
import { FilterItemProps } from './interfaces/filter.item.props';
import { FilterTypeEnum } from './enum/filter.type.enum';

export class FilterTextItem extends FilterItem {
  constructor(props: Omit<FilterItemProps, 'type'>) {
    super({ type: FilterTypeEnum.TEXT, ...props });
    this.defaultValue = '';
  }
}